import SliderInput from "./slider-inputs";

class CustomVolumeAireporter {

  private inputs = {
    text: document.querySelector('input[name="calculator_text"]') as HTMLInputElement,
    image: document.querySelector('input[name="calculator_image"]') as HTMLInputElement,
    neuro_search: document.querySelector('input[name="calculator_neuro_search"]') as HTMLInputElement,
  }
  private wrappers = {
    text: document.querySelector('.custom-volume__slider-input-text-gen') as HTMLElement,
    image: document.querySelector('.custom-volume__slider-input-image-gen') as HTMLElement,
    neuro_search: document.querySelector('.custom-volume__slider-input-neuro-search') as HTMLElement,
  }

  private displays = {
    text: document.querySelector('.custom-volume__slider-input-text-gen-display') as HTMLInputElement,
    image: document.querySelector('.custom-volume__slider-input-image-gen-display') as HTMLInputElement,
    neuro_search: document.querySelector('.custom-volume__slider-input-neuro-search-display') as HTMLInputElement,
  }

  private prices = {
    text: [0, 450, 950, 1950],
    image: [0, 250, 550, 1150],
    neuro_search: [0, 350, 750, 1450]
  }

  private totalPrice = document.querySelector('.custom-volume__total-price') as HTMLAnchorElement;

  constructor() {
    if(!this.inputs.text || !this.inputs.image || !this.inputs.neuro_search || !this.totalPrice) return;
    this.init();
  }

  private calculateTotalPrice() {
    if (!this.inputs.text || !this.inputs.image || !this.inputs.neuro_search || !this.totalPrice) return;

    const text = parseInt(this.inputs.text.value);
    const image = parseInt(this.inputs.image.value);
    const neuro_search = parseInt(this.inputs.neuro_search.value);
    const textNamesArray = JSON.parse(this.displays.text.dataset.names as string);
    const imageNamesArray = JSON.parse(this.displays.image.dataset.names as string);
    const neuroSearchNamesArray = JSON.parse(this.displays.neuro_search.dataset.names as string);
    const totalPrice = this.prices.text[text] + this.prices.image[image] + this.prices.neuro_search[neuro_search] as number;

    const textString = textNamesArray[text - 1] 
      ? `text=${textNamesArray[text - 1].toLowerCase().trim()}`
      : '';
    const imageString = imageNamesArray[image - 1] 
      ? `image=${imageNamesArray[image - 1].toLowerCase().trim()}`
      : '';
    const neuroSearchString = neuroSearchNamesArray[neuro_search - 1] 
      ? `search=${neuroSearchNamesArray[neuro_search - 1].toLowerCase().trim()}`
      : '';

    const currencyString = this.totalPrice.dataset.currencyString;
    this.totalPrice.textContent = `${totalPrice.toString()} ${currencyString}`;


    this.totalPrice.href = `https://app.aireporter.pro/?${textString}${textString && (imageString || neuroSearchString) ? '&' : ''}${imageString}${(textString || imageString ) && neuroSearchString ? '&' : ''}${neuroSearchString}`;
  }
  
  private createCustomSliders() {
    const textInput = new SliderInput(this.wrappers.text, {
      onTitleInputChange: (value: number) => {
        this.calculateTotalPrice();
        const namesArray = JSON.parse(this.displays.text.dataset.names as string);
        const priceArray = this.prices.text;
        this.updateDisplay(this.inputs.text, this.displays.text, namesArray, priceArray);
      }
    });
    const imageInput = new SliderInput(this.wrappers.image, {
      onTitleInputChange: (value: number) => {
        this.calculateTotalPrice();
        const namesArray = JSON.parse(this.displays.image.dataset.names as string);
        const priceArray = this.prices.image;
        this.updateDisplay(this.inputs.image, this.displays.image, namesArray, priceArray);
      }
    });
    const neuroSearchInput = new SliderInput(this.wrappers.neuro_search, {
      onTitleInputChange: (value: number) => {
        this.calculateTotalPrice();
        const namesArray = JSON.parse(this.displays.neuro_search.dataset.names as string);
        const priceArray = this.prices.neuro_search;
        this.updateDisplay(this.inputs.neuro_search, this.displays.neuro_search, namesArray, priceArray);
      }
    });
  }


  private updateDisplay(input: HTMLInputElement, display: HTMLInputElement, namesArray: string[], priceArray: number[]) {
    const currencyString = this.totalPrice.dataset.currencyString as string;
    const inputValue = parseInt(input.value);
    if (inputValue > 0 && namesArray) {
      const name = namesArray[inputValue - 1];
      display.value = `${name} · ${priceArray[inputValue]} ${currencyString}`
    } else {
      display.value = ``
    }
  }

  private init() {
    this.createCustomSliders();
    this.calculateTotalPrice();
  }
}

export default function customVolumeAireporter() {
  return new CustomVolumeAireporter();
}

// Посты: мин 1 и макс 1000
// Источники: мин 1 и макс 100
// Закрытые источники: Источники: мин 1 и макс 100

// Цена в кнопке = 
// 15 руб * (Количество постов) +
// 100 руб * (Количество источников) +
// 250 руб * (Количество закрытых источников) +